import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import './About.css';

const About = () => {
  return (
    <>
      <SEO
        title="About Us"
        description="Learn about IdeaPetal Games - a destination for free online puzzle and arcade games."
        keywords="about IdeaPetal, game developers, online games company"
      />
      <div className="about-page">
        <div className="about-header">
          <div className="container">
            <h1>About IdeaPetal Games</h1>
            <p className="subtitle">Creating Fun, One Game at a Time</p>
          </div>
        </div>

        <div className="about-content">
          <div className="container">
            <section className="about-section">
              <h2>Our Mission</h2>
              <p>
                At IdeaPetal Games, we believe that gaming should be accessible to everyone. Our mission is to provide
                high-quality, free-to-play mini games that bring quick entertainment to players of all ages.
              </p>
            </section>

            <section className="about-section">
              <h2>What We Do</h2>
              <p>
                We develop and host browser games that are easy to pick up, quick to replay, and friendly on desktop,
                tablet, and mobile devices. Our first focus is puzzle and classic arcade games that can grow into a
                sustainable web game collection.
              </p>
            </section>

            <section className="about-section">
              <h2>Our Values</h2>
              <div className="values-grid">
                <div className="value-item">
                  <h3>Fun First</h3>
                  <p>We prioritize enjoyable experiences that players can understand quickly and replay often.</p>
                </div>
                <div className="value-item">
                  <h3>Free Access</h3>
                  <p>Our browser games are free to play, with no required downloads or subscriptions.</p>
                </div>
                <div className="value-item">
                  <h3>Accessibility</h3>
                  <p>Our games are built to work across devices with simple controls and readable interfaces.</p>
                </div>
                <div className="value-item">
                  <h3>Continuous Improvement</h3>
                  <p>We use player feedback and analytics to improve games and decide what to build next.</p>
                </div>
              </div>
            </section>

            <section className="about-section">
              <h2>Our Games</h2>
              <p>
                We feature Snake Garden, Memory Bloom, and Petal 2048. We are expanding the library with
                quick, accessible games designed for replay, daily challenges, and score chasing.
              </p>
            </section>

            <section className="about-section">
              <h2>Get in Touch</h2>
              <p>
                Have questions, suggestions, feedback, or advertising inquiries? Visit our{' '}
                <Link to="/contact">Contact</Link> page to reach out.
              </p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
